module.exports = __webpack_public_path__ + "img/view-icon.bbef5eb9.svg";